import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input } from "@angular/core";

@Component({
  selector: "terminated-card",
  templateUrl: "terminated-card.html",
  styleUrls: ["terminated-card.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe],
})
export class TerminatedCardComponent {
  date = input.required<string>();
}
